import { useEffect, useState } from 'react';

// Escritura inmediata: si después se cambia de pantalla, el efecto de useStoredList no llega a ejecutarse
export const writeStoredList = <T>(key: string, items: T[]) => {
  try {
    localStorage.setItem(key, JSON.stringify(items));
  } catch (e) {
    // sin localStorage
  }
};

// Lista guardada en localStorage
export const useStoredList = <T>(key: string, initial: T[]) => {
  const [items, setItems] = useState<T[]>(() => {
    try {
      const saved = localStorage.getItem(key);
      const parsed = saved ? JSON.parse(saved) : null;
      if (Array.isArray(parsed) && parsed.length > 0) return parsed;
    } catch (e) {
      // sin localStorage
    }
    return initial;
  });

  useEffect(() => {
    try {
      localStorage.setItem(key, JSON.stringify(items));
    } catch (e) {
      // sin localStorage
    }
  }, [key, items]);

  return [items, setItems] as const;
};
